import {FloatingWidgetConfigurationInput,} from "../../../Contracts/WidgetTypes/FloatingWidgetType";
import {FloatingWidgetConfigurationError} from "../Errors/FloatingWidgetConfigurationError";
import {isValidWidgetTrigger} from "./TriggerValidator";
import {isValidCheckoutTheme} from "./WidgetOptionValidator";

export const isValidFloatingWidgetConfiguration = (configuration: FloatingWidgetConfigurationInput): configuration is FloatingWidgetConfigurationInput => {
    if(!configuration.experiencesForTickets && !configuration.experiencesForVouchers && !configuration.flexOffers) {
        throw FloatingWidgetConfigurationError.noExperiencesForTicketsOrVouchers();
    }
    if(configuration.experiencesForTickets && !Array.isArray(configuration.experiencesForTickets)) {
        throw FloatingWidgetConfigurationError.experienceListIsNotAnArray('experiencesForTickets');
    }
    if(configuration.experiencesForVouchers && !Array.isArray(configuration.experiencesForVouchers)) {
        throw FloatingWidgetConfigurationError.experienceListIsNotAnArray('experiencesForVouchers');
    }
    if(configuration.experiencesForTickets && configuration.experiencesForVouchers) {
        const hasExperiences = configuration.experiencesForTickets.length > 0 || configuration.experiencesForVouchers.length > 0;
        const hasFlexOffers = configuration.flexOffers && configuration.flexOffers.length > 0;
        if(!hasExperiences && !hasFlexOffers) {
            throw FloatingWidgetConfigurationError.noExperiencesForTicketsOrVouchers();
        }
    }
    if(configuration.trigger) {
        isValidWidgetTrigger(configuration.trigger);
    }

    if(configuration.checkoutTheme) {
        isValidCheckoutTheme(configuration.checkoutTheme);
    }
    return true;
}